module.exports = __webpack_public_path__ + "static/img/yinliangjian.4817318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliangjian.png
// module id = S3lx
// module chunks = 24